import { Link, NavLink, useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { GlobalSearch } from './GlobalSearch';

export function Shell(props: { children: React.ReactNode }) {
  const location = useLocation();
  const isLanding = location.pathname === '/';
  const isExplore = location.pathname === '/explore' || location.pathname === '/browse';
  const isJourneys = location.pathname === '/journeys';
  const isJourneyDetail = /^\/journeys\/.+/.test(location.pathname);
  const isStudy = location.pathname === '/study';
  const isModule = location.pathname.startsWith('/m/');
  const isSearch = location.pathname === '/search';
  const isCompare = location.pathname.startsWith('/compare');
  const isOnboarding = location.pathname === '/onboarding';
  const isGuide = location.pathname === '/how-it-works';
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <div
      className={`app-shell mk-shell${isLanding ? ' wi-shell-home' : ''}${isExplore ? ' wi-shell-explore' : ''}${isJourneys || isJourneyDetail ? ' wi-shell-journeys' : ''}${isStudy ? ' wi-shell-study' : ''}${isModule ? ' wi-shell-module app-shell--module wi-shell-module-immersive' : ''}${isSearch ? ' wi-shell-search' : ''}${isCompare ? ' wi-shell-compare' : ''}${isOnboarding ? ' wi-shell-onboarding' : ''}${isGuide ? ' wi-shell-guide' : ''}`}
    >
      {!isModule ? (
        <header className={`top-nav portal-topbar mk-topbar${scrolled ? ' wi-topbar-scrolled' : ''}`}>
          <div className="topbar-inner">
            <div className="brand-cluster mk-brand-cluster">
              <div className="brand-text">
                <Link to="/" className="brand-title mk-brand">
                  <span className="brand-title-prefix">Why</span>{' '}
                  <span className="brand-title-accent">Islam</span>
                </Link>
                <a className="brand-subtitle mk-brand-subtitle" href="https://the-muslim.org/">
                  Al-Muslim
                </a>
              </div>
            </div>
            <nav className="nav-links nav-links--center mk-nav" aria-label="Primary">
              <NavLink to="/" end className="mk-nav-link">
                Home
              </NavLink>
              <NavLink to="/explore" className="mk-nav-link">
                Big Ideas
              </NavLink>
              <NavLink to="/browse" className="mk-nav-link">
                Browse
              </NavLink>
              <NavLink to="/journeys" className="mk-nav-link">
                Journeys
              </NavLink>
            </nav>
            <div className="topbar-actions mk-top-actions">
              <GlobalSearch />
              <NavLink to="/study" className={({ isActive }) => `topbar-cta btn btn-primary btn-sm${isActive ? ' active' : ''}`}>
                My Space
              </NavLink>
            </div>
          </div>
        </header>
      ) : null}
      <main
        className={`app-main mk-main mk-main-wide${isLanding ? ' app-main--landing' : ''}${isExplore ? ' app-main--explore' : ''}${isJourneys || isJourneyDetail ? ' app-main--journeys' : ''}${isStudy ? ' app-main--study' : ''}${isModule ? ' app-main--module' : ''}${isSearch ? ' app-main--search' : ''}${isCompare ? ' app-main--compare' : ''}${isOnboarding ? ' app-main--onboarding' : ''}${isGuide ? ' app-main--guide' : ''}`}
      >
        {props.children}
      </main>
      <footer className="site-footer mk-footer">
        <div className="site-footer-grid mk-footer-inner">
          <div className="wi-footer-brand">
            <p className="footer-mark mk-footer-brand">Why Islam</p>
            <p className="muted mk-footer-tagline">A guided inquiry sanctuary for thoughtful, structured exploration.</p>
            <p className="muted wi-footer-parent">An Al-Muslim platform</p>
          </div>
          <div className="wi-footer-columns">
            <div className="footer-links mk-footer-col">
              <p className="wi-footer-title">Topics</p>
              <Link to="/explore">Big Ideas</Link>
              <Link to="/browse">Browse library</Link>
              <Link to="/m/what-is-tawhid">Foundations</Link>
            </div>
            <div className="footer-links mk-footer-col">
              <p className="wi-footer-title">Journeys</p>
              <Link to="/journeys">All journeys</Link>
              <Link to="/journeys/exploring-islam-for-the-first-time">Start here</Link>
            </div>
            <div className="footer-links mk-footer-col">
              <p className="wi-footer-title">My Space</p>
              <Link to="/study">My Space</Link>
            </div>
            <div className="footer-links mk-footer-col">
              <p className="wi-footer-title">About</p>
              <Link to="/how-it-works">How it works</Link>
              <a href="https://the-muslim.org/why-islam">Why Islam</a>
              <a href="https://the-muslim.org/">Al-Muslim</a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
